// src/api.js

import axios from 'axios';

const isTestMode = process.env.REACT_APP_LOCAL_MODE === "true";

const instance = axios.create({
  baseURL: isTestMode ? process.env.REACT_APP_TEST_URL_BACKEND : process.env.REACT_APP_LIVE_URL_BACKEND, // L'URL del tuo backend
  timeout: 5000 // Timeout per le richieste
});

export default instance;
